import { useMutation, useQuery } from 'react-query';
import { AxiosError } from 'axios';
import { RemotePhsPstRepo } from '@repository/phs/pst/PhsPstRepo';
import PhsPstMock from './PhsPstMock';
import { PstResultVO } from '@domain/vo/phs/pst/result/PstResultVO';

const remotePhsPstRepo = new RemotePhsPstRepo();
const remotePhsPstMockRepo = new PhsPstMock();

const phsPstResultsKeys = ['phs', 'pst'];

const fetchPHSPSTResults = async (sn: number) => {
  const { data } = await remotePhsPstRepo.fetchPHSPSTResults(sn);
  return new PstResultVO(data);
};

const usePHSPSTResults = (sn: number, enabled: boolean) => {
  return useQuery([...phsPstResultsKeys, 'phsResult', sn], () => fetchPHSPSTResults(sn), {
    enabled,
  });
};

const usePHSPSTResultSelectMatching = (onSuccess?: () => void, onError?: (e: AxiosError) => void) => {
  return useMutation((applySn: number) => remotePhsPstRepo.fetchPHSPSTResultsSelectMatching(applySn), {
    onSuccess,
    onError,
  });
};

export { phsPstResultsKeys, usePHSPSTResults, usePHSPSTResultSelectMatching };
